import { ApiClient } from '@/config/axios.config';
import type { BalticRoute, BalticHistoryPoint, BalticHistoryRequest } from '@/types/baltic.types';
import { mockBalticRoutes, mockBalticHistory } from '@/data/mockBalticData';
import { environment } from '@/config/environment';

export class BalticService {
  private static readonly BASE_PATH = '/v1/baltic';

  /**
   * Fetch all Baltic routes
   */
  static async getRoutes(): Promise<BalticRoute[]> {
    try {
      const data = await ApiClient.get<BalticRoute[]>(`${this.BASE_PATH}/route`);
      // Ensure dates are handled properly even if null/undefined
      return data.map((route) => ({
        ...route,
        tiDate: route.tiDate || null,
        biDate: route.biDate || null,
      }));
    } catch (error) {
      // In development mode, fall back to mock data if API fails
      if (!environment.production) {
        console.warn('Baltic API failed, using mock data:', error);
        return mockBalticRoutes;
      }
      throw error;
    }
  }

  /**
   * Fetch historical data for a specific route
   */
  static async getHistoryData(request: BalticHistoryRequest): Promise<BalticHistoryPoint[]> {
    try {
      return await ApiClient.post<BalticHistoryPoint[]>(`${this.BASE_PATH}/history`, request);
    } catch (error) {
      // In development mode, fall back to mock data if API fails
      if (!environment.production) {
        console.warn('Baltic history API failed, using mock data:', error);
        console.log('Mock Baltic history:', mockBalticHistory);
        return mockBalticHistory;
      }
      throw error;
    }
  }
}
